import { ReviewInsightsChildRoutes } from '../../core/enums';
import { Dictionary } from '@ngrx/entity';
import { InsightsMethod } from '../../models/review-insights-models/insights-method';
import { InsightsLocalStoreState } from './review-insights-local-store.service';
import { LocationComparisonActions, LocationComparisonCountActions, PostsPerWeekdayActions, PostTimesActions, RatingActions, RespondedCommentedActions, ResponseTimesActions, ResponseTimesOverviewActions, ReviewNumbersActions, TopLocationsActions } from './state/insights-actions';

export function getRefreshActionsForInsightsPage(url: string, isSyncLocationComparisonTableSettingsReq?: boolean): any[] {
  switch (true) {
    case url.includes(ReviewInsightsChildRoutes.NUMBER_OF_REVIEWS):
      return [ReviewNumbersActions.getReviewNumbers()];
    case url.includes(ReviewInsightsChildRoutes.LOCATION_COMPARISON):
      if (isSyncLocationComparisonTableSettingsReq)
        return [LocationComparisonActions.getLocationComparisonList()];
      else
        return [LocationComparisonActions.getLocationComparisonList(),
          LocationComparisonCountActions.getLocationComparisonCount()];
    case url.includes(ReviewInsightsChildRoutes.RATINGS):
      return [RatingActions.getRating()];
    case url.includes(ReviewInsightsChildRoutes.RESPONDED_COMMENTED):
      return [RespondedCommentedActions.getRespondedCommented()];
    case url.includes(ReviewInsightsChildRoutes.POST_TIME):
      return [PostTimesActions.getPostTimes()];
    case url.includes(ReviewInsightsChildRoutes.RESPONSE_TIME):
      return [ResponseTimesActions.getResponseTimes()];
    default: // OVERVIEW - refresh all
      return [RatingActions.getRating(),
        TopLocationsActions.getTopLocations(),
        RespondedCommentedActions.getRespondedCommented(),
        ResponseTimesOverviewActions.getResponseTimesOverview(),
        PostsPerWeekdayActions.getPostsPerWeekday(),
        ReviewNumbersActions.getReviewNumbers()];
  }
}

export const InsightsMethodsByActionTypes: Dictionary<InsightsMethod> = {
  [RatingActions.getRating.type]: InsightsMethod.RATINGS,
  [TopLocationsActions.getTopLocations.type]: InsightsMethod.TOP_LOCATIONS,
  [RespondedCommentedActions.getRespondedCommented.type]: InsightsMethod.RESPONDED_COMMENTED,
  [ResponseTimesOverviewActions.getResponseTimesOverview.type]: InsightsMethod.RESPONSE_TIMES_OVERVIEW,
  [PostsPerWeekdayActions.getPostsPerWeekday.type]: InsightsMethod.POSTS_PER_WEEKDAY,
  [ReviewNumbersActions.getReviewNumbers.type]: InsightsMethod.NUMBER_OF_REVIEWS,
  [LocationComparisonActions.getLocationComparisonList.type]: InsightsMethod.LOCATION_COMPARISON_LIST,
  [LocationComparisonCountActions.getLocationComparisonCount.type]: InsightsMethod.LOCATION_COMPARISON_COUNT,
  [PostTimesActions.getPostTimes.type]: InsightsMethod.POST_TIMES,
  [ResponseTimesActions.getResponseTimes.type]: InsightsMethod.RESPONSE_TIMES,
};

export const InsightsErrorKeysByActionTypes: Dictionary<keyof InsightsLocalStoreState> = {
  [RatingActions.getRating.type]: 'ratingErrorOccurred',
  [TopLocationsActions.getTopLocations.type]: 'topLocationsErrorOccurred',
  [RespondedCommentedActions.getRespondedCommented.type]: 'respondedCommentedErrorOccurred',
  [ResponseTimesOverviewActions.getResponseTimesOverview.type]: 'responseTimesOverviewErrorOccurred',
  [PostsPerWeekdayActions.getPostsPerWeekday.type]: 'postsPerWeekdayErrorOccurred',
  [ReviewNumbersActions.getReviewNumbers.type]: 'reviewNumbersErrorOccurred',
  [LocationComparisonActions.getLocationComparisonList.type]: 'locationComparisonListErrorOccurred',
  [LocationComparisonCountActions.getLocationComparisonCount.type]: 'locationComparisonCountErrorOccurred',
  [PostTimesActions.getPostTimes.type]: 'postTimesErrorOccurred',
  [ResponseTimesActions.getResponseTimes.type]: 'responseTimesErrorOccurred',
};
